module.exports = vendor_d2b878c744ba98f50fa1;